var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "invite-setting px-4",
    staticStyle: {
      "height": "calc(100vh - 186px)"
    }
  }, [_c('Card', {
    staticClass: "mb-4",
    attrs: {
      "title": $t("itasrr4", "邀请设置"),
      "dis-hover": ""
    }
  }, [_c('div', {
    staticClass: "flex flex-col gap-2"
  }, [_c('div', {
    staticClass: "p-3 rounded-md"
  }, [_c('Form', {
    ref: "formRef",
    staticClass: "w-full flex h-full",
    attrs: {
      "model": _vm.inviteForm,
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('div', {
    staticClass: "flex-1 flex gap-4"
  }, [_c('FormItem', {
    attrs: {
      "label": $t("df6s344", "有效期限"),
      "prop": "validityType"
    }
  }, [_c('Select', {
    staticClass: "firefox-select-focus-fix w-full",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": $t("x7skfb7", "请选择有效期限"),
      "transfer": ""
    },
    model: {
      value: _vm.inviteForm.validityType,
      callback: function ($$v) {
        _vm.$set(_vm.inviteForm, "validityType", $$v);
      },
      expression: "inviteForm.validityType"
    }
  }, _vm._l(_vm.validityTypeList, function (item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": $t("pgxs2", "部门")
    }
  }, [_c('div', {
    staticClass: "pro_input_add bg-white min-w-[200px] flex gap-1",
    on: {
      "click": _vm.changeDepartment
    }
  }, [_vm._l(_vm.orgList.slice(0, 4), function (item, index) {
    return _c('span', {
      key: index,
      staticClass: "item border-[#DFE4EE] border-solid border-[1px] rounded-sm p-[5px] text-[14px] text-[14px] leading-[14px] text-[#000]"
    }, [_c('Icon', {
      staticClass: "mr-[2px] text-[#2d8cf0]",
      attrs: {
        "type": "md-folder"
      }
    }), _vm._v(" " + _vm._s(item.name) + " ")], 1);
  }), _vm.orgList.length > 4 ? _c('span', {
    staticClass: "item border-[#DFE4EE] border-solid border-[1px] rounded-sm p-[5px] text-[14px] text-[14px] leading-[14px] text-[#000]"
  }, [_vm._v(" +" + _vm._s(_vm.orgList.length - 4) + " ")]) : _vm._e()], 2)]), _c('div', {
    staticClass: "approval-setting"
  }, [_c('i-switch', {
    staticClass: "approval-switch",
    attrs: {
      "true-value": "T",
      "false-value": "F"
    },
    model: {
      value: _vm.inviteForm.needApprove,
      callback: function ($$v) {
        _vm.$set(_vm.inviteForm, "needApprove", $$v);
      },
      expression: "inviteForm.needApprove"
    }
  }), _c('span', {
    staticClass: "approval-tip"
  }, [_vm._v($t("4mu4s8h", "是否需要管理员审批新成员的加入申请"))])], 1)], 1), _c('div', {
    staticClass: "flex gap-3 items-center"
  }, [_c('Button', {
    staticClass: "flex-1",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(` ${$t("xypn696", "生成邀请链接")} `)]), _c('Button', {
    staticClass: "flex-1 bg-[#E9ECEF] hover:bg-[#DEE2E6] text-[#495057] border-none",
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(` ${$t("avkfr54", "全部重置")} `)])], 1)])], 1)]), _c('invite-link', {
    ref: "inviteLinkModal",
    attrs: {
      "value": _vm.inviteFormInfo
    }
  })], 1), _c('invite-link-drawer', {
    ref: "inviteLinkDrawer",
    on: {
      "edit": _vm.editInviteLink,
      "check": _vm.checkInvite,
      "clear": _vm.clearInviteLink
    }
  }), _c('org-tree-modal', {
    ref: "orgTreeModalRef",
    on: {
      "on-update": _vm.getData
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };